import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil, PaginationUtil } from 'src/app/common/util';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CloseTransferDetailsRequest, DetailClosureTransfer, TransferRequestedDetailResponse, TransferRequestedResponse, TransferRequestedSummaryResponse, InventoryQuantityByProductResponse } from 'src/app/models/transfer-product.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { UserSaved } from 'src/app/models/user.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';

@Component({
  selector: 'app-history-transfer-products',
  templateUrl: './history-transfer-products.component.html',
  styleUrls: ['./history-transfer-products.component.scss']
})
export class HistoryTransferProductsComponent implements OnInit {
  waitingFor = null;
  gettingData = true;
  gettingDataSummary = true;
  deleting: { [key: number]: boolean } = {};
  pagination = new PaginationModel(0, 5, 0, 0, [], []);
  paginationSummary = new PaginationModel(0, 5, 0, 0, [], []);
  warehousesName: { [key: number]: string } = {};
  showed = null;
  user: UserSaved = null;
  warehouses: WarehouseResponse[] = [];
  warehouse: number = null;
  startDate: any;
  endDate: any;
  todayDate = new Date();
  detailing: { [key: string]: boolean } = {};
  existDiference: { [key: number]: boolean } = {};
  saving = false;

  permissionType = PermissionTypeEnum;
  summaryToggle = false;
  expandedSummary: {
      warehouseId: number;
      type: number;
  } | null = null;
  summaryProducts: {
      [key: string]: InventoryQuantityByProductResponse[]
  } = {};
  loadingSummaryProducts: {
      [key: string]: boolean
  } = {};
  errorSummaryProducts: {
      [key: string]: boolean
  } = {};
  summaryProductsVersion = 0;

  constructor(
    private toastService: ToastrService,
    private inventoryService: InventoryService,
    private warehouseService: WarehouseService,
    private authService: AuthenticationService,
  ) {
    var permissions = authService.getPermissions();
    this.user = authService.getUser();
    var today = new Date();
    this.endDate = today.toISOString().split("T")[0];
    today.setDate(today.getDate() - 30);
    this.startDate = today.toISOString().split("T")[0];
  }

  ngOnInit(): void {
    this.getWarehousesByUser();
  }

  getWarehousesByUser() {
    this.warehouseService.getWarehousesAllowedByUser(this.user.id).subscribe({
      next: (response: ResponseObject) => {
        if (response.data.length > 0) {
          response.data.forEach((w) => {
            this.warehousesName[w.id] = w.name;
          });
          this.warehouses = response.data;
          if (this.warehouses.length == 1) {
            this.warehouse = this.warehouses[0].id;
            if (this.summaryToggle) {
              this.getSummary();
            } else {
              this.getTransfersByCompany();
            }
          }
        } else {
          this.getWarehouses();
        }
      },
      error: (error) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        response.data.forEach((w) => {
          this.warehousesName[w.id] = w.name;
        });
        var allWarehouses = new WarehouseResponse();
        allWarehouses.id = -1;
        allWarehouses.name = "TODAS";
        response.data.unshift(allWarehouses);
        this.warehouses = response.data;
        this.warehouse = -1;
        if (this.summaryToggle) {
          this.getSummary();
        } else {
          this.getTransfersByCompany();
        }
      },
      error: (error) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getTransfersByCompany() {
    if (this.warehouse != null && this.startDate && this.endDate) {
      this.gettingData = true;
      this.inventoryService.getTransfersByCompany(
        this.warehouse,
        DateUtil.parseDateToMilliseconds(this.startDate),
        DateUtil.parseDateToMilliseconds(this.endDate)
      ).subscribe({
        next: (response: ResponseObject) => {
          this.pagination.total = (response.data as TransferRequestedResponse[])
            .sort((a, b) => b.creationDate - a.creationDate);

          this.pagination = PaginationUtil.reset(this.pagination);
          this.gettingData = false;
          this.getExistDiference();
        },
        error: (error) => {
          this.gettingData = false;
          this.toastService.error("Error al obtener las transferencias");
        }
      })
    } else {
      this.toastService.info("Rellena los campos primero");
    }
  }

  getSummary() {
    if (this.warehouse != null && this.startDate && this.endDate) {

      this.resetSummaryProducts();
      
      this.gettingDataSummary = true;
      this.inventoryService.getTransfersSummaryByCompany(
        this.warehouse,
        DateUtil.parseDateToMilliseconds(this.startDate),
        DateUtil.parseDateToMilliseconds(this.endDate)
      ).subscribe({
        next: (response: ResponseObject) => {
          this.paginationSummary.total = (response.data as TransferRequestedSummaryResponse[]);

          this.paginationSummary = PaginationUtil.reset(this.paginationSummary);
          this.gettingDataSummary = false;
        },
        error: (error) => {
          this.gettingDataSummary = false;
          this.toastService.error("Error al obtener resumen de transferencias");
        }
      })
    } else {
      this.toastService.info("Rellena los campos primero");
    }
  }

  getExistDiference() {
    for (let i = 0; i < this.pagination.total.length; i++) {
      const transfer = this.pagination.total[i];
      this.detailing[transfer.id] = true;
      this.existDiference[transfer.id] = false;
      this.inventoryService.getTransferDetailsByTransferId(transfer.id).subscribe({
        next: (response: ResponseObject) => {
          let tempDetails = response.data as TransferRequestedDetailResponse[];
          for (let j = 0; j < tempDetails.length; j++) {
            const detail = tempDetails[j];
            if (detail.quantityRequest != tempDetails[j].quantityReceived) {
              this.existDiference[transfer.id] = true;
              break;
            }
          }
          this.detailing[transfer.id] = false;
        },
        error: (error) => {
          // this.toastService.error("Error al obtener el detalle");
          // this.detailing[transfer.id] = false;
        }
      })
    }
  }

  showDetails(transfer: TransferRequestedResponse) {
    if (transfer.details) {
      var newTransfer = JSON.parse(JSON.stringify(transfer));
      this.showed = newTransfer;
    } else {
      this.inventoryService.getTransferDetailsByTransferId(transfer.id).subscribe({
        next: (response: ResponseObject) => {
          transfer.details = response.data as TransferRequestedDetailResponse[];
          var newTransfer = JSON.parse(JSON.stringify(transfer));
          this.showed = newTransfer;
        },
        error: (error) => {
          this.toastService.error("Error al obtener el detalle");
        }
      })
    }
  }

  save() {
    if (this.saving) return;
    if (!this.disabled()) return;

    this.saving = true;

    var request = new CloseTransferDetailsRequest();
    request.transferId = this.showed.id;
    request.details = [];
    this.showed.details.forEach(c => {
      var temp = new DetailClosureTransfer();
      temp.comment = c.type == 'miss' ? c.comment : '';
      temp.detailId = c.detailId;
      temp.quantityReceived = c.userQuantity;
      request.details.push(temp);
    });

    this.inventoryService.closeTransferDetails(request).subscribe({
      next: (response: ResponseObject) => {
        this.getTransfersByCompany();
        this.showed = null;
        this.toastService.success("Datos guardados exitosamente!");
        this.saving = false;
      },
      error: (error) => {
        this.toastService.error("Error al guardar");
        this.saving = false;
      }
    })
  }

  disabled() {
    if (this.showed) {
      var sum = 0;
      this.showed.details.forEach((d) => {
        sum += d.type ? 1 : 0;
      });
      return sum == this.showed.details.length;
    }
    return true;
  }


  changeFilter() {
    if (this.startDate && this.endDate) {
      var tempStart = new Date(this.startDate);
      var tempEnd = new Date(this.endDate);
      if (tempStart > this.todayDate || tempEnd > this.todayDate) {
        this.toastService.info("No puedes ingresar fechas más allá del día de hoy");
      } else {
        if (tempStart > tempEnd) {
          this.toastService.info("La fecha de inicio debe ser más lejana que la de final");
        } else {
          if (this.warehouse != null) {
            if (this.summaryToggle) {
              this.getSummary();
            } else {
              this.getTransfersByCompany();
            }
          } else {
            this.toastService.info("Selecciona una bodega primero");
          }
        }
      }
    }
  }

  toggleSummaryProducts(
      item: TransferRequestedSummaryResponse,
      type: number
  ): void {
      const warehouseId = Number(item.id);
      const key = `${warehouseId}-${type}`;

      if (
          this.expandedSummary &&
          this.expandedSummary.warehouseId === warehouseId &&
          this.expandedSummary.type === type
      ) {
          this.expandedSummary = null;
          return;
      }

      this.expandedSummary = {
          warehouseId,
          type
      };

      if (this.summaryProducts[key] !== undefined) {
          return;
      }

      if (this.loadingSummaryProducts[key]) {
          return;
      }

      this.loadingSummaryProducts[key] = true;
      this.errorSummaryProducts[key] = false;

      const version = this.summaryProductsVersion;

      this.inventoryService.getTransfersSummaryProductsByCompany(
          warehouseId,
          type,
          DateUtil.parseDateToMilliseconds(this.startDate),
          DateUtil.parseDateToMilliseconds(this.endDate)
      ).subscribe({
          next: (response: ResponseObject) => {

              if (version !== this.summaryProductsVersion) return;

              this.summaryProducts[key] = (response.data as InventoryQuantityByProductResponse[]) || [];
              this.loadingSummaryProducts[key] = false;
          },
          error: (error) => {

              if (version !== this.summaryProductsVersion) return;

              this.loadingSummaryProducts[key] = false;
              this.errorSummaryProducts[key] = true;

              this.toastService.error(
                  "Error al obtener el detalle de productos"
              );
          }
      });
  }

  resetSummaryProducts(): void {
      this.expandedSummary = null;
      this.summaryProducts = {};
      this.loadingSummaryProducts = {};
      this.errorSummaryProducts = {};
      this.summaryProductsVersion++;
  }
  
}
